import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';


import DropZone from 'components/Shared/DropZone';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';

import Avatar from '@mui/material/Avatar';


import ViewList from '@mui/icons-material/ViewList';
import ViewListOutlined from '@mui/icons-material/ViewListOutlined';
import LibraryAdd from '@mui/icons-material/LibraryAdd';
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';





import { ImportSouffranceDialogSteps } from './importSouffranceDialogSteps.js';


import QualificationSelect from 'components/Shared/QualificationSelect';


import { green, red, deepPurple } from '@mui/material/colors';


const styles = theme => ({
    formControl: {
        margin: 0,
        width: '100%'
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    link: theme.style.link,

    button: {
        margin: "0 8px"
    },
    rowWarning: {
        backgroundColor: theme.palette.table.row.warning
    },
    rowError: {
        backgroundColor: theme.palette.table.row.error
    },
    cellError: {
        backgroundColor: theme.palette.table.cell.error
    },


    cardsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'stretch'
    },
    card: {        
        flexGrow: '1',
        margin: "12px"
    },
    divider: {
        paddingTop: 16,
        paddingBottom: 16
    },

    content: {
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        flex: '1 1 auto',
        marginLeft: 12
    },
    avatar: {
        flex: '0 0 auto',
        marginRight: 12,
        width: 60,
        height: 60,
        color: '#fff'
    },

    avatarLignesNOK: {
        backgroundColor: red[700]
    },
    avatarLignesOK: {
        backgroundColor: green[700]
    },

    avatarReclamations: {
        backgroundColor: red[500]
    },
    
    avatarMemos: {
        backgroundColor: deepPurple[700]
    }
});



class ImportSouffranceDialog extends React.Component {


    render() {
        const { classes, onClickCancel, onClickSave, onChange, onChangeQualification, onChangeInclure, step, souffrancesTransporteur, sauvegardable, error, importResult } = this.props;
        
        return (
            <Dialog fullWidth maxWidth={false} scroll={'paper'} open>
                <DialogTitle>
                    Import d'un fichier de souffrance transporteur
                </DialogTitle>

                <DialogContent>
                        
                    {(step === ImportSouffranceDialogSteps.WaitFile) && (
                        <React.Fragment>
                            <Link to={`../RECLAMATIONS_import_souffrance_modele.xlsx`} target="_blank" className={classes.link}>
                                <Typography variant="button">
                                    Télécharger le fichier modèle
                                </Typography>
                            </Link>
                        </React.Fragment>
                    )}
                    
                    {(step === ImportSouffranceDialogSteps.WaitFile) && (
                        <React.Fragment>
                            <DropZone id="fichiersIds" name="fichiersIds" onChange={onChange} label="Fichier à importer" buttonLabel="Ajouter un fichier" />
                        </React.Fragment>

                    )}


                    {(step === ImportSouffranceDialogSteps.LoadFile) && (
                        <React.Fragment>
                            <p>
                                Traitement du fichier en cours
                            </p>
                        </React.Fragment>
                    )}


                    {(step === ImportSouffranceDialogSteps.SetSouffrances) && error && (
                        <React.Fragment>

                            <p>
                                "Une erreur est intervenue lors du traitement du fichier! "
                            </p>
                            <p>
                                {error.error.message} - {error.error.response.statusText}
                            </p>
                            <p>
                                <span dangerouslySetInnerHTML={{ __html: error.error.response.data }} />
                            </p>

                        </React.Fragment>
                    )}

                    {(step === ImportSouffranceDialogSteps.SetSouffrances) && (!souffrancesTransporteur || souffrancesTransporteur === null || souffrancesTransporteur.length === 0) && !error && (
                        <React.Fragment>

                            <p>
                                "Le fichier ne contient pas de souffrance"
                            </p>

                        </React.Fragment>
                    )}


                    {(step === ImportSouffranceDialogSteps.SetSouffrances) && souffrancesTransporteur && souffrancesTransporteur.length > 0 && (
                        <React.Fragment>
                                                       
                             <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Compte Transporteur</TableCell>
                                        <TableCell>Nom Transporteur</TableCell>
                                        <TableCell>Numéro Préparation</TableCell>
                                        <TableCell>Récépissé</TableCell>
                                        <TableCell>Motif</TableCell>
                                        <TableCell>Qualification</TableCell>
                                        <TableCell>Commentaire</TableCell>
                                        <TableCell>Importer</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>

                                    {souffrancesTransporteur.map((souffrance, index) => (
                                        <TableRow key={index} className={souffrance.erreur !== 0 ? classes.rowError : (souffrance.qualificationId === 0) ? classes.rowWarning : ''} >
                                            <TableCell className={(souffrance.erreur === 2) ? classes.cellError : ''}>{souffrance.compteTransporteur}</TableCell>
                                            <TableCell className={(souffrance.erreur === 1) ? classes.cellError : ''}>{souffrance.nomTransporteur}</TableCell>
                                            <TableCell>{souffrance.numeroPreparation}</TableCell>
                                            <TableCell>{souffrance.recepisse}</TableCell>
                                            <TableCell>{souffrance.motifTransporteur}</TableCell>
                                            <TableCell>
                                                <QualificationSelect
                                                    disabled={souffrance.erreur !== 0}
                                                    value={souffrance.qualificationId}
                                                    onChange={e => onChangeQualification(e, index)}
                                                    categorieId={this.props.categorieId}
                                                    isRequired={false}
                                                    noLabel
                                                />
                                            </TableCell>
                                            <TableCell>{souffrance.commentaire}</TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    disabled={(souffrance.erreur !== 0)}
                                                    checked={souffrance.inclure}
                                                    onChange={e => onChangeInclure(e, index)}
                                                    value="inclure"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>

                            

                        </React.Fragment>
                      )}


                    {(step === ImportSouffranceDialogSteps.WaitImport) && (
                        <React.Fragment>
                            <p>
                                Import du fichier en cours
                            </p>
                        </React.Fragment>

                    )}


                    {(step === ImportSouffranceDialogSteps.ImportResult) && error && (
                        <React.Fragment>

                            <p>
                                "Une erreur est intervenue lors du traitement des souffrances "
                            </p>
                            <p>
                                {error.error.message} - {error.error.response.statusText}
                            </p>
                            <p>
                                <span dangerouslySetInnerHTML={{ __html: error.error.response.data }} />
                            </p>

                        </React.Fragment>
                    )}

                    {(step === ImportSouffranceDialogSteps.ImportResult) && importResult && (      
                        <div>
                            <div className={classes.cardsContainer}>

                                <Card className={classes.card}>
                                    <CardContent>
                                        <div className={classes.content}>
                                            <Avatar className={classNames(classes.avatar, classes.avatarLignesNOK)}>
                                                <ViewList />
                                            </Avatar>
                                            <div className={classes.title}>
                                                <Typography variant="subtitle1" gutterBottom>Non prises en compte</Typography>
                                                <Typography variant="h6" gutterBottom>{importResult.nombreNonPriseEnCompte}</Typography>
                                            </div>
                                        </div>
                                        <div className={classes.divider}>
                                            <Divider />
                                        </div>
                                        <Typography variant="caption">{`Nombre de lignes non prises en compte`}</Typography>
                                    </CardContent>
                                </Card>

                                <Card className={classes.card}>
                                    <CardContent>
                                        <div className={classes.content}>
                                            <Avatar className={classNames(classes.avatar, classes.avatarLignesOK)}>
                                                <ViewListOutlined />
                                            </Avatar>
                                            <div className={classes.title}>
                                                <Typography variant="subtitle1" gutterBottom>Prises en compte</Typography>
                                                <Typography variant="h6" gutterBottom>{importResult.nombrePriseEnCompte}</Typography>
                                            </div>
                                        </div>

                                        <div className={classes.divider}>
                                            <Divider />
                                        </div>
                                        <Typography variant="caption">{`Nombre de lignes prises en compte`}</Typography>
                                    </CardContent>
                                </Card>

                                <Card className={classes.card}>
                                    <CardContent>
                                        <div className={classes.content}>
                                            <Avatar className={classNames(classes.avatar, classes.avatarReclamations)}>
                                                <LibraryAdd />
                                            </Avatar>
                                            <div className={classes.title}>
                                                <Typography variant="subtitle1" gutterBottom>Dossiers après-vente</Typography>
                                                <Typography variant="h6" gutterBottom>{importResult.reclamationsAjouteesIds.length}</Typography>
                                            </div>
                                        </div>

                                        <div className={classes.divider}>
                                            <Divider />
                                        </div>
                                        <Typography variant="caption">{`Nombre de dossiers après-vente ajoutés`}</Typography>
                                    </CardContent>
                                </Card>

                                <Card className={classes.card}>
                                    <CardContent>
                                        <div className={classes.content}>
                                            <Avatar className={classNames(classes.avatar, classes.avatarMemos)}>
                                                <QuestionAnswer />
                                            </Avatar>
                                            <div className={classes.title}>
                                                <Typography variant="subtitle1" gutterBottom>Mémos</Typography>
                                                <Typography variant="h6" gutterBottom>{importResult.actionsAjoutees.length}</Typography>
                                            </div>
                                        </div>

                                        <div className={classes.divider}>
                                            <Divider />
                                        </div>
                                        <Typography variant="caption">{`Nombre d'actions "mémo" ajoutées`}</Typography>
                                    </CardContent>
                                </Card>
                                                           
                    
                            </div>

                            {importResult.nombreErreurCRM !==0  && (
                                <Typography component="p" variant="caption">{`Il y a eu ${importResult.nombreErreurCRM} erreur(s) d'envoi de CRM.`}</Typography>
                            )}

                            {importResult.nombreMailErreurs !== 0 && (
                                <Typography component="p" variant="caption">{`Il y a eu ${importResult.nombreMailErreurs} erreur(s) d'envoi de mail.`}</Typography>
                            )}

                            {importResult.nombreFichierErreurs !== 0 && (
                                <Typography component="p" variant="caption">{`Il y a eu ${importResult.nombreFichierErreurs} erreur(s) de création de fichier FMCP.`}</Typography>
                            )}


                        </div>
                    )}


                </DialogContent>

                <DialogActions>


                    {(step !== ImportSouffranceDialogSteps.ImportResult) && (
                        <React.Fragment>

                            <Button
                                onClick={onClickCancel}
                                color="primary"
                                className={classes.button}
                                disabled={step === ImportSouffranceDialogSteps.WaitImport}
                            >
                                Annuler
                            </Button>
                            <Button
                                disabled={!sauvegardable || (step !== ImportSouffranceDialogSteps.SetSouffrances)}
                                onClick={onClickSave}
                                variant="contained"
                                color="secondary"
                            >
                                Enregistrer
                                {(step === ImportSouffranceDialogSteps.WaitImport) && <CircularProgress size={24} className={classes.buttonProgress}  />}
                            </Button>

                        </React.Fragment>
                    )}

                    
                    {(step === ImportSouffranceDialogSteps.ImportResult) && (
                        <Button onClick={onClickCancel} color="secondary" variant="contained" className={classes.button}>OK</Button>
                    )}

                </DialogActions>
            </Dialog>
        );
    }
}


ImportSouffranceDialog.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    
    onChange: PropTypes.func.isRequired,
    onChangeQualification: PropTypes.func.isRequired,
    onChangeInclure: PropTypes.func.isRequired,
    
    sauvegardable: PropTypes.bool.isRequired,

    step: PropTypes.number.isRequired,

    importResult: PropTypes.object,

    souffrancesTransporteur: PropTypes.array,
    categorieId: PropTypes.number.isRequired
};

export default withStyles(styles)(ImportSouffranceDialog);